export const clientReportTemplateButton = {
	action: 'handleCalyxReportDownload',
	disabled: false,
	icon: ['fal', 'cloud-download'],
	text: 'Calyx Report Template',
	// class: 'b360-btn--disabled',
};
export const excelTemplateButton = {
	action: 'handleExcelDownload',
	disabled: false,
	icon: ['fal', 'cloud-download'],
	text: 'Excel Contact Template',
	// class: 'b360-btn--disabled',
};
export const jobAidButton = {
	disabled: true,
	emitAction: 'handleJobAidDownload',
	caption: 'Need Help?',
	class: 'b360-btn--disabled',
};
export const STATIC_ASSET_ID = {
	jobAid: 1,
	clientReportTemplate: 2,
	excelTemplate: 3,
};
